export var ChangeOp;
(function (ChangeOp) {
    ChangeOp["CHANGE_OP_UPSERT"] = "UPSERT";
    ChangeOp["CHANGE_OP_DELETE"] = "DELETE";
    ChangeOp["CHANGE_OP_MOVE"] = "MOVE";
})(ChangeOp || (ChangeOp = {}));
